/**
 * Form for add plan dialog
 * 
 * @author JHO 
 * Last changed: 19.01.2021
 * Changes: Initial implementation
 */

 import React, {useEffect, useState} from 'react';
 import { makeStyles } from '@material-ui/core';
 import TextField from '@material-ui/core/TextField';
 import Button from '@material-ui/core/Button';
 import SaveIcon from '@material-ui/icons/Save';
 import axios from 'axios';
 import * as endpoints from '../../../service/endpoints';
 import { useTranslation } from 'react-i18next';
import {checkError401, formatTimestamp} from "../../../common/helpers";
import DateFnsUtils from '@date-io/date-fns';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import locale from 'date-fns/locale/en-US'
import { useSnackbar } from 'notistack';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
  } from '@material-ui/pickers';
import * as constants from "../../../common/constants";
 
 const useStyles = makeStyles(theme => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
      },
   root: {
     padding: theme.spacing(2),
 
     '& .MuiTextField-root': {
        margin: theme.spacing(1),
        width: '25ch',
     }
   },
    buttons : {
        position: 'absolute',
        right: theme.spacing(3),
        bottom: theme.spacing(3),
    }
 }));
 
 const AddPlanForm = (props) => {
   const classes = useStyles();
   const { t } = useTranslation();
   const { enqueueSnackbar } = useSnackbar();
   const [dateFrom, setDateFrom] = useState(new Date());
   const [dateTo, setDateTo] = useState(new Date());
   const [shift, setShift] = useState("");
   const [area, setArea] = useState("");
   const [assignedTo, setAssignedTo] = useState("");
   const [priority, setPriority] = useState("");
   const [note, setNote] = useState("")
   const [name, setName] = useState("")

   const httpConfig = {
    headers: { Authorization: `Bearer ${props.token}` }
  };

   const handleDateChangeFrom = (date) => {
    setDateFrom(date);
  };

  const handleDateChangeTo = (date) => {
    setDateTo(date);
  };

  const handleSubmit = e => {
    e.preventDefault();
    const planBody = {
      "name": name,
      "dateFrom": formatTimestamp(dateFrom,"export",""),
      "dateTo": formatTimestamp(dateTo,"export",""),
      "shift": shift,
      "area": area,
      "client": "LNC",
      "assignedTo": assignedTo,
      "priority": priority,
      "notes": note,
      "articles": [],
      "measures": [],
      "numberOfSKUs": 0,
      "measuredSKUs": 0
    };

    axios.post(endpoints.PLANS,planBody,httpConfig)
    .then(response => {
      enqueueSnackbar(t('notification_success_add_plan'), {
        variant: 'success',
        autoHideDuration: props.userSettings.notification_time ? props.userSettings.notification_time*1000 : constants.NOTIFICATION_TIME_DEFAULT*1000
      });
      props.handleClose();
    })
    .catch(error => {
      enqueueSnackbar(t('notification_error_add_plan'), {
        variant: 'error',
        autoHideDuration: props.userSettings.notification_time ? props.userSettings.notification_time*1000 : constants.NOTIFICATION_TIME_DEFAULT*1000
      });
      props.handleClose();
    })
  };

  
  if (locale && locale.options) {
    locale.options.weekStartsOn = 1
  }

   return (
     <form className={classes.root} onSubmit={handleSubmit}>
         <div>
       <TextField
         label={"Name"}
         value={name}
         variant="outlined"
         required
         type="text"
         onChange={e => setName(e.target.value)}
       />
       </div>
         <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
         <div>
         <KeyboardDatePicker
          disableToolbar
          variant="inline"
          format="dd/MM/yyyy"
          margin="normal"
          id="date-picker-inline"
          label="Date From"
          value={dateFrom}
          onChange={handleDateChangeFrom}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
        />
       <KeyboardDatePicker
          disableToolbar
          variant="inline"
          format="dd/MM/yyyy"
          margin="normal"
          id="date-picker-inline"
          label="Date To"
          value={dateTo}
          onChange={handleDateChangeTo}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
        />
        </div>
       </MuiPickersUtilsProvider>
       <div>
       <FormControl className={classes.formControl} variant="outlined">
        <InputLabel id="assigned-label">Assigned to</InputLabel>
        <Select
          required
          labelId="assigned-label"
          id="assigned-select"
          value={assignedTo}
          label="Assigned to"
          onChange={e => setAssignedTo(e.target.value)}
        >
          {props.users.map((option) => (

           option?.permissionLevel <= props.permissionLevel && (
            <MenuItem key={option?._id} value={option?._id}>
              {option?.userName}
            </MenuItem>
            )
          ))}
        </Select>
      </FormControl>
       </div>
       <div>
       <TextField
         label={"Notes"}
         value={note}
         variant="outlined"
         type="text"
         onChange={e => setNote(e.target.value)}
       />
       </div>
       <div className={classes.buttons}>
         <Button type="submit" variant="contained" color="secondary" textColor="white" startIcon={<SaveIcon />}>
           Create
         </Button>
       </div>
     </form>
   );
 };
 
 export default AddPlanForm;